import { useContent } from '@/content'
import { Icon, Surface } from '@/components/ui'
import styles from './ResearchList.module.css'

/** Thesis work, most recent first. */
export const ThesisList = () => {
  const { research } = useContent()

  return (
    <Surface pad={20} radius="shell" className={styles.panel}>
      <h1 className="t-24">Research</h1>
      <ul className={styles.list}>
        {research.map((entry) => (
          <Surface as="li" key={entry.id} interactive className={styles.entry}>
            <div className={styles.head}>
              <p className={`t-12 ${styles.level}`}>{entry.level}</p>
              <p className={`t-12 ${styles.period}`}>{entry.period}</p>
            </div>

            <h2 className={`t-18 ${styles.title}`}>{entry.title}</h2>

            <div className={`t-12 ${styles.meta}`}>
              <span>Supervisors: {entry.supervisors.join(', ')}</span>
              {entry.grade && (
                <span className={styles.grade}>Grade: {entry.grade}</span>
              )}
            </div>

            <ul className={styles.highlights}>
              {entry.highlights.map((item) => (
                <li key={item.slice(0, 40)} className={`t-14 ${styles.highlight}`}>
                  <Icon name="arrowRight" size={13} className={styles.bullet} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </Surface>
        ))}
      </ul>
    </Surface>
  )
}

/** Doctoral preparation: areas of study, not completed work. */
export const ResearchInterests = () => {
  const { researchInterests } = useContent()

  return (
    <Surface pad={20} radius="shell" className={styles.panel}>
      <div>
        <h2 className="t-24">{researchInterests.heading}</h2>
        <p className={`t-14 ${styles.summary}`}>{researchInterests.summary}</p>
      </div>
      <ul className={styles.interests}>
        {researchInterests.areas.map((area) => (
          <Surface as="li" key={area.name} interactive className={styles.interest}>
            <h3 className={`t-18 ${styles.interestName}`}>{area.name}</h3>
            <p className={`t-14 ${styles.interestDetail}`}>{area.detail}</p>
          </Surface>
        ))}
      </ul>
    </Surface>
  )
}

/** Competition results. */
export const Distinctions = () => {
  const { distinctions } = useContent()

  return (
    <Surface pad={20} radius="shell" className={styles.panel}>
      <h2 className="t-24">Distinctions</h2>
      <ul className={styles.list}>
        {distinctions.map((item) => (
          <Surface as="li" key={item.id} interactive className={styles.entry}>
            <div className={styles.head}>
              <h3 className={`t-18 ${styles.title}`}>{item.name}</h3>
              <p className={`t-12 ${styles.level}`}>{item.year}</p>
            </div>
            <p className={`t-14 ${styles.interestDetail}`}>{item.detail}</p>
          </Surface>
        ))}
      </ul>
    </Surface>
  )
}

/** Academic referees. */
export const References = () => {
  const { references } = useContent()

  return (
    <Surface pad={20} radius="shell" className={styles.panel}>
      <h2 className="t-24">References</h2>
      <ul className={styles.references}>
        {references.map((person) => (
          <Surface as="li" key={person.id} interactive className={styles.reference}>
            <p className={`t-18 ${styles.refName}`}>{person.name}</p>
            <p className={`t-14 ${styles.refTitle}`}>{person.title}</p>
            <p className={`t-12 ${styles.refInstitution}`}>{person.institution}</p>
          </Surface>
        ))}
      </ul>
    </Surface>
  )
}
